<script setup>
import { computed } from 'vue'
import { Head } from '@inertiajs/vue3'

const props = defineProps({
    title: String,
    description: String,
    publishedDate: String,
    modifiedDate: String,
    featuredImage: String,
    category: String,
    slug: String,
    wordCount: Number
})

const articleSchema = computed(() => ({
    "@context": "https://schema.org",
    "@type": "Article",
    "@id": `https://www.seclock.com/education/entry/${props.slug}#article`,
    "headline": props.title,
    "description": props.description,
    "image": props.featuredImage,
    "datePublished": props.publishedDate,
    "dateModified": props.modifiedDate || props.publishedDate,
    "inLanguage": "en-US",
    "author": {
        "@type": "Organization",
        "@id": "https://www.seclock.com/#organization",
        "name": "SECLOCK"
    },
    "publisher": {
        "@type": "Organization",
        "@id": "https://www.seclock.com/#organization",
        "name": "SECLOCK"
    },
    "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": `https://www.seclock.com/education/entry/${props.slug}`,
        "name": props.title
    },
    "articleSection": props.category,
    "wordCount": props.wordCount
}))
</script>

<template>
    <Head>
        <component is="script" type="application/ld+json">
            {{ JSON.stringify(articleSchema) }}
        </component>
    </Head>
</template>
